import cloudUpload from './src'
cloudUpload.install = (Vue) => {
  Vue.component(cloudUpload.name, cloudUpload)
}
export default cloudUpload



// WEBPACK FOOTER //
// ./packages/cloudUpload/index.js